import * as m from "motion/react-m";

export function Outer({ className }: { className?: string }) {
  return (
    <m.svg
      animate={{ opacity: 1 }}
      className={className}
      fill='none'
      id='outer'
      initial={{ opacity: 0 }}
      viewBox='0 0 679 322'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M92.5817 1C156.73 0.99819 331.194 152.858 339.085 160.767H339.55C339.55 160.767 339.471 160.845 339.317 161C339.471 161.155 339.55 161.233 339.55 161.233C339.55 161.233 339.393 161.233 339.085 161.233C331.194 169.142 156.73 321.002 92.5817 321C34.9288 320.998 1.0029 241 1.0029 161.233L1.00145 161C1.00137 160.923 1 160.844 1 160.767C1 77.5217 34.9288 1.00196 92.5817 1Z'
        stroke='black'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeOpacity='0.28'
      />
      <path
        d='M586.838 1C522.69 0.99819 348.226 152.858 340.335 160.767H339.87C339.87 160.767 339.949 160.845 340.103 161C339.949 161.155 339.87 161.233 339.87 161.233C339.87 161.233 340.027 161.233 340.335 161.233C348.226 169.142 522.69 321.002 586.838 321C644.491 320.998 678.417 241 678.417 161.233L678.418 161C678.419 160.923 678.42 160.844 678.42 160.767C678.42 77.5217 644.491 1.00196 586.838 1Z'
        stroke='black'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeOpacity='0.28'
      />
    </m.svg>
  );
}

export function OuterFilled({ className }: { className?: string }) {
  return (
    <m.svg
      animate={{ opacity: 1 }}
      className={className}
      fill='none'
      id='outer-filled'
      initial={{ opacity: 0 }}
      viewBox='0 0 679 322'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M92.5817 1C156.73 0.99819 331.194 152.858 339.085 160.767H339.55C339.55 160.767 339.471 160.845 339.317 161C339.471 161.155 339.55 161.233 339.55 161.233C339.55 161.233 339.393 161.233 339.085 161.233C331.194 169.142 156.73 321.002 92.5817 321C34.9288 320.998 1.0029 241 1.0029 161.233L1.00145 161C1.00137 160.923 1 160.844 1 160.767C1 77.5217 34.9288 1.00196 92.5817 1Z'
        fill='#F0EDEA'
        stroke='black'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M586.838 1C522.69 0.99819 348.226 152.858 340.335 160.767H339.87C339.87 160.767 339.949 160.845 340.103 161C339.949 161.155 339.87 161.233 339.87 161.233C339.87 161.233 340.027 161.233 340.335 161.233C348.226 169.142 522.69 321.002 586.838 321C644.491 320.998 678.417 241 678.417 161.233L678.418 161C678.419 160.923 678.42 160.844 678.42 160.767C678.42 77.5217 644.491 1.00196 586.838 1Z'
        fill='#F0EDEA'
        stroke='black'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M341.245 160.767H341.06L341.153 161M464.54 62.5C471.664 90.2866 475.553 124.903 475.553 160.767C475.553 160.844 475.552 160.923 475.552 161L475.552 161.233C475.552 195.991 471.574 230.792 464.294 259'
        opacity='0.28'
        stroke='black'
        strokeDasharray='0.01 6'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
      <path
        d='M538.502 16.7598C563.886 43.3826 576.393 100.301 576.393 160.767C576.393 160.844 576.392 160.923 576.392 161L576.391 161.233C576.391 219.552 563.721 277.994 538.002 305.207'
        stroke='black'
        strokeDasharray='0.01 6'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeOpacity='0.28'
        strokeWidth='2'
      />
      <path
        d='M339.366 160.767H339.551L339.458 161M215.944 63C208.901 90.7013 205.059 125.117 205.059 160.767C205.059 160.844 205.059 160.923 205.059 161L205.06 161.233C205.06 195.991 209.037 230.792 216.317 259'
        opacity='0.28'
        stroke='black'
        strokeDasharray='0.01 6'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
      <path
        d='M140.891 16.7598C115.506 43.3826 103 100.301 103 160.767C103 160.844 103.001 160.923 103.001 161L103.002 161.233C103.002 219.552 115.671 277.994 141.391 305.207'
        stroke='black'
        strokeDasharray='0.01 6'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeOpacity='0.28'
        strokeWidth='2'
      />
    </m.svg>
  );
}
